import { render, staticRenderFns } from "./extra-details-children.vue?vue&type=template&id=4c6a4de6&"
import script from "./extra-details-children.vue?vue&type=script&lang=js&"
export * from "./extra-details-children.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports